// eslint-disable-next-line no-restricted-imports
import {
  Query_LegalClientController_GetList_AllOf_1_List_Items_FinancialMonitoring_FinanceInfo_AmlPolicyReviewFrequency as AmlPolicyReviewFrequencyApi,
  Query_LegalClientController_GetList_AllOf_1_List_Items_FinancialMonitoring_FinanceInfo_MonetaryServiceTransactionCountForLastSixMonths as MonetaryServiceTransactionCountForLastSixMonthsApi,
  FinancialMonitoringDto_Input,
} from 'api/generated/graphql';
import { LegalClientFinancialMonitoringParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

export const parseFinancialMonitoringParam = (
  params: LegalClientFinancialMonitoringParam
): FinancialMonitoringDto_Input => ({
  isSubjectToRegulation: params.isSubjectToRegulation,
  financeInfo: params.financeInfo
    ? {
        ...params.financeInfo,
        amlPolicyReviewFrequency:
          AmlPolicyReviewFrequencyApi[
            params.financeInfo.amlPolicyReviewFrequency
          ],
        monetaryServiceTransactionCountForLastSixMonths:
          MonetaryServiceTransactionCountForLastSixMonthsApi[
            params.financeInfo.monetaryServiceTransactionCountForLastSixMonths
          ],
        dateOfLastCheck: params.financeInfo.dateOfLastCheck
          ? formatToISODate(params.financeInfo.dateOfLastCheck)
          : undefined,
      }
    : undefined,

  globalInfo: params.globalInfo
    ? {
        partOne: {
          supervisoryAuthorityNameAndLocation:
            params.globalInfo.supervisoryAuthorityNameAndLocation,

          hasMandatoryAmlRegulations:
            params.globalInfo.hasMandatoryAmlRegulations!,

          mandatoryAmlRegulation: params.globalInfo.mandatoryAmlRegulation
            ? {
                regulationDetails:
                  params.globalInfo.mandatoryAmlRegulation.regulationDetails!,
                authorizedBodyName:
                  params.globalInfo.mandatoryAmlRegulation.authorizedBodyName!,
              }
            : undefined,

          lastAmlAuditResult: params.globalInfo.lastAmlAuditResult,

          hadInvestigationsOrSanctions:
            params.globalInfo.hadInvestigationsOrSanctions!,

          amlDecisionDateAndAuthorityInfo:
            params.globalInfo?.amlDecisionDateAndAuthorityInfo,

          hasInternalAmlDocuments: params.globalInfo?.hasInternalAmlDocuments!,

          internalAmlDocuments: params.globalInfo.internalAmlDocuments
            ? {
                adoptionDate: formatToISODate(
                  params.globalInfo.internalAmlDocuments.adoptionDate!
                ),
                lastUpdateDate: formatToISODate(
                  params.globalInfo.internalAmlDocuments.lastUpdateDate!
                ),
                hasEffectivenessAssessmentProcedures:
                  params.globalInfo.internalAmlDocuments
                    .hasEffectivenessAssessmentProcedures!,
                lastEffectivenessCheckInfo:
                  params.globalInfo.internalAmlDocuments
                    .lastEffectivenessCheckInfo,
                appliesToForeignAffiliates:
                  params.globalInfo.internalAmlDocuments
                    .appliesToForeignAffiliates,
              }
            : undefined,

          hasDepartmentsResponsibleForAmlFunctions:
            params.globalInfo?.hasDepartmentsResponsibleForAmlFunctions!,

          amlFunctionDepartmentsNames:
            params.globalInfo?.amlFunctionDepartmentsNames,

          hasResponsibleAmlManager:
            params.globalInfo?.hasResponsibleAmlManager!,

          responsibleAmlManager: params.globalInfo.responsibleAmlManager
            ? {
                fullName: params.globalInfo.responsibleAmlManager.fullName!,
                position: params.globalInfo.responsibleAmlManager.position!,
                email: params.globalInfo.responsibleAmlManager.email!,
                phoneNumber:
                  params.globalInfo.responsibleAmlManager.phoneNumber!,
              }
            : undefined,

          hasRiskManagementProcedures:
            params.globalInfo.hasRiskManagementProcedures,
        },
        partTwo: {
          hasSourceOfFundsProcedures:
            params.globalInfo.hasSourceOfFundsProcedures,
          hasRelationshipsWithPEPProcedures:
            params.globalInfo.hasRelationshipsWithPEPProcedures,
          hasAnonymousAccounts: params.globalInfo.hasAnonymousAccounts,
          hasAnonymousAccountPreventionProcedures:
            params.globalInfo.hasAnonymousAccountPreventionProcedures,
          hasTransactionMonitoringProcedures:
            params.globalInfo.hasTransactionMonitoringProcedures,
          hasAssetFreezingProcedures:
            params.globalInfo.hasAssetFreezingProcedures,

          hasAMLTrainingProcedures: params.globalInfo.hasAMLTrainingProcedures,
          amlTrainingDetails: params.globalInfo.amlTrainingDetails,

          hasBranchesInNonFATFCountries:
            params.globalInfo.hasBranchesInNonFATFCountries,
          nonFATFBranchesNamesAndLocations:
            params.globalInfo.nonFATFBranchesNamesAndLocations,

          hasCorrespondentsInNonFATFCountries:
            params.globalInfo.hasCorrespondentsInNonFATFCountries,
          nonFATFCorrespondentsNames:
            params.globalInfo.nonFATFCorrespondentsNames,

          hasCorrespondentsInOffshoreZones:
            params.globalInfo.hasCorrespondentsInOffshoreZones,
          offshoreCorrespondentsNames:
            params.globalInfo.offshoreCorrespondentsNames,

          hasShellBankRelationships:
            params.globalInfo.hasShellBankRelationships,
          shellBanksNames: params.globalInfo.shellBanksNames,

          hasShellBankPreventionProcedures:
            params.globalInfo.hasShellBankPreventionProcedures,
          hasCDDRequestComplianceProcedures:
            params.globalInfo.hasCDDRequestComplianceProcedures,

          creditRating: params.globalInfo.creditRating,
          subsidiariesNamesAndLocations:
            params.globalInfo.subsidiariesNamesAndLocations,
          keyPartnersNames: params.globalInfo.keyPartnersNames,
          foreignBranchesNamesAndLocations:
            params.globalInfo.foreignBranchesNamesAndLocations,
          financialGroupInfo: params.globalInfo.financialGroupInfo,

          hasSanctionPolicyDocuments:
            params.globalInfo.hasSanctionPolicyDocuments,
          hasSanctionsMonitoringProcedures:
            params.globalInfo.hasSanctionsMonitoringProcedures,
          isUnderSanctionsOrControlledBySanctionedEntity:
            params.globalInfo.isUnderSanctionsOrControlledBySanctionedEntity,
          isListedInSanctionLists: params.globalInfo.isListedInSanctionLists,
          isLinkedToSanctionedEntities:
            params.globalInfo.isLinkedToSanctionedEntities,
        },
      }
    : undefined,
});
